<evc-platform
  [inputLeftBar]="leftMenu()"
  [inputHelpMenu]="helpMenu()"
  [inputSettingsMenu]="settingsMenu()"
  [displayApplicationsIcon]="isOnline()"
  [inputAppIdentification]="appIdentity"
  [displayUserMenu]="!isOnPremise"
  [inputForcedLayout]="topbarLayout"
  (isLeftbarOpenChange)="toggleLeftBar($event)"

>
  <div top-bar-extra-settings class="top-bar-settings">
    @if (isDevelopment()) {
      <app-dev-menu />
    }

    @if (applicationMode()?.platform === "desktop") {
      @if (isDevelopment()) {
        <app-zoom-control />
      }

      <app-desktop-menu />
    }

    <app-locale-selector />
  </div>

  <ng-container leftbar-top-content leftbarTopContent />



  <ng-content />
</evc-platform>
